// src/container/Intro/Intro.jsx
import React, { useEffect, useRef } from 'react';
import { Heart, HeartHandshake, PencilRuler, Rabbit, Drumstick } from 'lucide-react';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import '../Intro/Intro.css';

const Intro = () => {
    const refs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-slide-in');
                    } else {
                        entry.target.classList.remove('animate-slide-in');
                    }
                });
            },
            { threshold: 0.0001 }
        );

        refs.current.forEach(ref => {
            if (ref) {
                observer.observe(ref);
            }
        });

        return () => {
            refs.current.forEach(ref => {
                if (ref) {
                    observer.unobserve(ref);
                }
            });
        };
    }, []);

    return (
        <div className="app__engagement flex__center section__padding" id="engagements">
            <div className="app__engagement-content flex__center">
                <div className="app__engagement-content_history">
                    <h1 className="headtext__cormorant mt-10">Nos engagements</h1>
                    <img src={images.chopstickSide} style={{ filter: 'invert(0.5) sepia(1) saturate(5) hue-rotate(10deg)'}} alt="intro__chopstick" className="chopstick__img" />

                    <main className="flex container mx-auto py-20 justify-center items-center">
                        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                            <div ref={el => refs.current[0] = el}
                                 className="p-4 border border-[#FADB70] rounded-[12px] flex flex-col small-wide bg-[#1D1D1D] center-content">
                                <img src={images.stew} alt="fait_maison"
                                     className="w-full h-[140px] object-contain object-center rounded-[8px]" />
                                <span className="text-[16px] headtext__cormorant3 text-[#FADB70] text-center">Fait maison</span>
                                <Rabbit size={40} className="text-purple-500" strokeWidth={1.4} />
                                <span className="text-[16px] text-[#AAAAAA] text-center">Ingrédients frais et de qualité</span>
                            </div>

                            <div ref={el => refs.current[3] = el}
                                 className="p-4 border border-[#FADB70] rounded-[12px] flex flex-col justify-center items-center gap-4 col-span-1 md:col-span-1 bg-[#1D1D1D] h-64">
                                <HeartHandshake size={40} className="text-purple-500" strokeWidth={1.4} />
                                <span className="headtext__cormorant3 text-[12px] text-[#FADB70]">Hygiène</span>
                                <img src={images.niveauHigiene} alt="about_spoon"
                                     className="w-full h-[140px] object-contain object-center rounded-[8px] mb-5" />
                            </div>

                            <div ref={el => refs.current[5] = el}
                                 className="p-4 border border-[#FADB70] rounded-[12px] flex flex-col gap-1 col-span-1 row-span-1 bg-[#1D1D1D] h-64">
                                <PencilRuler size={40} className="text-purple-500" strokeWidth={1.4} />
                                <img src={images.etoiles} alt="qualite"
                                     className="h-[64px] object-contain object-center rounded-[8px]" />
                                <span className="text-[16px] headtext__cormorant3 text-[#FADB70] text-center">Qualité</span>
                                <span className="text-[16px] text-[#AAAAAA] text-center">4.8 étoiles avis Google Maps</span>
                            </div>

                            <div ref={el => refs.current[2] = el}
                                 className="p-4 border border-[#FADB70] rounded-[12px] flex flex-col gap-1 small-long bg-[#1D1D1D] bg-cover bg-no-repeat bg-center w-75 h-64"
                                 style={{ backgroundImage: `url(${images.plats})` }}>
                            </div>

                            <div ref={el => refs.current[1] = el}
                                 className="p-4 border border-[#FADB70] rounded-[12px] flex flex-col gap-4 small-long bg-[#1D1D1D]">
                                <div className="inline-content">
                                    <div className="mr-10">
                                        <Drumstick size={40} className="text-purple-500" strokeWidth={1.4} />
                                    </div>
                                </div>
                                <div className="inline-center">
                                    <img src={images.halal} alt="halal"
                                         className="h-[64px] object-contain object-left rounded-[8px]" />
                                    <span className="text-[28px] headtext__cormorant3 text-[#FADB70] ml-4"> Halal</span>
                                </div>
                                <span className="text-[16px] text-[#AAAAAA] text-center">Viandes Halal et Respectueuses</span>
                            </div>

                            <div ref={el => refs.current[4] = el}
                                 className="p-4 border border-[#FADB70] rounded-[12px] flex flex-col gap-1 col-span-1 row-span-1 bg-[#1D1D1D]">
                                <Heart size={40} className="text-purple-500" strokeWidth={1.4} />
                                <img src={images.smiling} alt="chaleureux"
                                     className="h-[80px] object-contain object-center rounded-[8px]" />
                                <span className="text-[20px] headtext__cormorant4 center-content">Chaleureux</span>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Intro;